import { NeedStatus } from "../../autogen/bff-api";

export const EVERY_STATUS_WITH_OWN_DRAFTS = Object.values(NeedStatus).join(",");
